module.exports = __webpack_public_path__ + "static/media/Leccion-10-15-Bases-del-Ministerio.2f1d2743.pdf";